<div style="height: 100%; width: 100%;">
<optima-explorer 
  #checkInExplorer
  [isLoading]="isLoading()"
  [explorerAttributes]="explorerAttributes"
  [contentTotalCount]="getContentTotalCount()"
  [contentItemCountPerPage]="contentItemCountPerPage"
  [dataRefreshedToken]="dataRefreshedToken"
  (paginationRequest)="onPaginationRequest($event)"
  (subHeaderOnClickAddButtonOptionEmitter)="onAddButtonOptionClick($event)"
  (subHeaderOnForwardButtonClickedEmitter)="itemClicked($event)"
  (explorerNavonExplorerNavOnItemRightClickEmitter)="processContentContextMenuClicked($event)"
  (explorerNavOnNavItemClickedEmitter)="navItemClicked($event)"
  (explorerContentOncontextMenuClickEmitter)="processContentContextMenuClicked($event)">
</optima-explorer>
</div>
<!-- <app-off-canvas-collective></app-off-canvas-collective> -->